import { registryApi } from '../clients/AxiosClients'

const cadastrarCronograma = async (body) => {
	return registryApi.post(
		'v1/cronogramadeordemdeservico/cadastrar-cronograma-de-ordem-de-servico',
		body,
	)
}

const atualizarRegrasDeOtimizacao = async (cronogramaId, body) => {
	return registryApi.put(
		`v1/cronogramadeordemdeservico/atualizar-regras-de-otimizacao/${cronogramaId}`,
		body,
	)
}

const atualizarFiltroUsadoNoCronograma = async (cronogramaId, body) => {
	return registryApi.put(
		`v1/cronogramadeordemdeservico/atualizar-filtro-usado-no-cronograma/${cronogramaId}`,
		body,
	)
}

const listarCronogramas = async () => {
	return registryApi.get('v1/cronogramadeordemdeservico/listar')
}

const cadastrarOrdensDeServico = async (cronogramaId, body) => {
	return registryApi.post(
		`v1/cronogramadeordemdeservico/criar-ordens-de-servico-dos-planejamentos/${cronogramaId}`,
		body,
	)
}

const excluirCronograma = async (cronogramaId) => {
	return registryApi.delete(`v1/cronogramadeordemdeservico/excluir-cronograma/${cronogramaId}`)
}

const atualizarCronogramaDeOS = async (body) => {
	return registryApi.put(
		'v1/cronogramaDeOrdemDeServico/atualizar-cronograma-ordem-de-servico',
		body,
	)
}
export {
	cadastrarCronograma,
	cadastrarOrdensDeServico,
	atualizarRegrasDeOtimizacao,
	atualizarFiltroUsadoNoCronograma,
	listarCronogramas,
	excluirCronograma,
	atualizarCronogramaDeOS,
}
